export default __webpack_public_path__ + "static/media/507.d4446f4b.gif";